import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { axiosBeelineRequest } from '@beef/utils';
export var fetchCaptcha = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$axiosBeelineRe, data, headers, _JSON$parse, key, captcha;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axiosBeelineRequest({
            url: '/captcha.ashx',
            method: 'get',
            withCredentials: true,
            originalResponse: true,
            responseType: 'blob',
            params: params
          });
        case 2:
          _yield$axiosBeelineRe = _context.sent;
          data = _yield$axiosBeelineRe.data;
          headers = _yield$axiosBeelineRe.headers;
          if (!headers['content-type'].includes('image/gif')) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", new Promise(function (res) {
            var reader = new FileReader();
            reader.onloadend = function () {
              res({
                captcha: reader.result
              });
            };
            reader.readAsDataURL(data);
          }));
        case 7:
          if (!headers['content-type'].includes('application/json')) {
            _context.next = 16;
            break;
          }
          _context.t0 = JSON;
          _context.next = 11;
          return data.text();
        case 11:
          _context.t1 = _context.sent;
          _JSON$parse = _context.t0.parse.call(_context.t0, _context.t1);
          key = _JSON$parse.captchakey;
          captcha = _JSON$parse.captcha;
          return _context.abrupt("return", {
            captcha: "data:image/gif;base64,".concat(captcha),
            key: key
          });
        case 16:
          return _context.abrupt("return", {});
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchCaptcha(_x) {
    return _ref.apply(this, arguments);
  };
}();